import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";
import logo from "../img/logo.svg";
import DTLogo from "../img/dti_logo.png";
import { getProfile, logout } from "../actions/user";
import { getUserDetails } from "../selectors/user";
import HeaderDTI from "./HeaderDTI";

const Header = ({ getProfile, getUserDetails, userDetails, logout }) => {
  const [filtersOpen, setFiltersOpen] = useState(false);
  const {
    userData,
    isFetching: userDataIsFetching,
    isFetched: userDataIsFetched,
  } = userDetails;

  const history = useHistory();

  useEffect(() => {
    getProfile();
  }, []);

  const toggleFiltersOpen = () => {
    setFiltersOpen(!filtersOpen);
  };

  let roleType = "";
  if (userDetails.isFetched && userDetails.userData) {
    roleType = userDetails.userData.role.type;
  }

  const signout = async () => {
    try {
      await logout();
      history.push("/login");
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <>
      {(roleType === "subinspector" ||
        roleType === "regional_inspector" ||
        roleType === "dip_admin") && <HeaderDTI />}
      {!(
        roleType === "subinspector" ||
        roleType === "regional_inspector" ||
        roleType === "dip_admin"
      ) && (
        <>
          <div className="container-fluid mx-auto printHide">
            <nav className="bg-white dark:bg-gray-800 shadow">
              <div className="max-w-7xl mx-auto px-8">
                <div className="flex items-center justify-between h-16">
                  <div className="flex items-center">
                    {!(
                      roleType === "subinspector" ||
                      roleType === "regional_inspector" ||
                      roleType === "dip_admin"
                    ) && (
                      <>
                        <Link className="flex-shrink-0" to="/dashboard">
                          <img
                            className="w-64 h-12"
                            src={logo}
                            alt="Logo SSM"
                          />
                        </Link>
                        <div className="">
                          <div className="ml-10 flex items-baseline space-x-4">
                            <Link to="/dashboard">
                              <div className="text-gray-800 hover:text-blue px-3 py-2 rounded-md text-sm font-medium">
                                Почетна
                              </div>
                            </Link>
                            <Link to="/issues">
                              <div className="text-gray-800 hover:text-blue px-3 py-2 rounded-md text-sm font-medium">
                                Пријаве
                              </div>
                            </Link>
                            <Link to="/posts">
                              <div className="text-gray-800 hover:text-blue px-3 py-2 rounded-md text-sm font-medium">
                                Новости
                              </div>
                            </Link>
                            <Link to="/advice">
                              <div className="text-gray-800 hover:text-blue px-3 py-2 rounded-md text-sm font-medium">
                                Савети
                              </div>
                            </Link>
                            {/* <Link to="/administrators">
                              <div className="text-gray-800 hover:text-blue px-3 py-2 rounded-md text-sm font-medium">
                                Администратори
                              </div>
                            </Link> */}
                            <Link to="/users">
                              <div className="text-gray-800 hover:text-blue px-3 py-2 rounded-md text-sm font-medium">
                                Корисници
                              </div>
                            </Link>
                            <div>
                              <div onClick={toggleFiltersOpen}>
                                <div
                                  href="#"
                                  className="text-gray-800 hover:text-blue px-3 py-2 rounded-md text-sm font-medium"
                                >
                                  Статистики
                                </div>
                              </div>
                              <div
                                className={`absolute t-0 l-0 w-48 p-3 min-h-32 bg-white rounded-md shadow ${
                                  filtersOpen ? "block" : "hidden"
                                }`}
                              >
                                <div className="flex flex-col">
                                  <Link
                                    to="/statsByAge"
                                    className="text-gray-800 hover:text-blue px-3 py-2 rounded-md text-sm font-medium"
                                  >
                                    Статистика о узрасту
                                  </Link>
                                  <Link
                                    to="/statsByGender"
                                    className="text-gray-800 hover:text-blue px-3 py-2 rounded-md text-sm font-medium"
                                  >
                                    Статистика о полу
                                  </Link>

                                  <Link
                                    to="/statsByCity"
                                    className="text-gray-800 hover:text-blue px-3 py-2 rounded-md text-sm font-medium"
                                  >
                                    Статистика о месту
                                  </Link>
                                  <Link
                                    to="/statsByEmployment"
                                    className="text-gray-800 hover:text-blue px-3 py-2 rounded-md text-sm font-medium"
                                  >
                                    Статистика о запосленима
                                  </Link>
                                  <Link
                                    to="/statsByMembership"
                                    className="text-gray-800 hover:text-blue px-3 py-2 rounded-md text-sm font-medium"
                                  >
                                    Статистика о чланству у синдикат
                                  </Link>
                                  <Link
                                    to="/statsByReports"
                                    className="text-gray-800 hover:text-blue px-3 py-2 rounded-md text-sm font-medium"
                                  >
                                    Статистика о пријавама о себи/о другима
                                  </Link>
                                  <Link
                                    to="/statsByAnonimity"
                                    className="text-gray-800 hover:text-blue px-3 py-2 rounded-md text-sm font-medium"
                                  >
                                    Статистика о анонимним пријавама
                                  </Link>
                                  {/* <Link
                                    to="/statsByReportType"
                                    className="text-gray-800 hover:text-blue px-3 py-2 rounded-md text-sm font-medium"
                                  >
                                    Статистика о типу пријаве
                                  </Link> */}
                                  <Link
                                    to="/statsByReportStatus"
                                    className="text-gray-800 hover:text-blue px-3 py-2 rounded-md text-sm font-medium"
                                  >
                                    Статистика о статусу пријаве
                                  </Link>
                                  <Link
                                    to="/statsByCategory"
                                    className="text-gray-800 hover:text-blue px-3 py-2 rounded-md text-sm font-medium"
                                  >
                                    Статистика о повреди права
                                  </Link>
                                  <Link
                                    to="/statsByIndustry"
                                    className="text-gray-800 hover:text-blue px-3 py-2 rounded-md text-sm font-medium"
                                  >
                                    Статистика о делатности
                                  </Link>
                                </div>
                              </div>
                            </div>
                            <Link to="/profile">
                              <div className="text-gray-800 hover:text-blue px-3 py-2 rounded-md text-sm font-medium">
                                Профил
                              </div>
                            </Link>
                            <button
                              type="submit"
                              onClick={signout}
                              className="text-gray-800 hover:text-blue px-3 py-2 rounded-md text-sm font-medium"
                            >
                              Одјавa
                            </button>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </nav>
          </div>
        </>
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  userDetails: getUserDetails(state),
});

const mapDispatchToProps = {
  getProfile,
  logout,
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);
